exports.ByName = {
  Accepted: { Id: 0, Name: 'Accepted' },
  Rejected: { Id: 1, Name: 'Rejected' },
  AcceptedAndReviewed: { Id: 2, Name: 'Accepted and Reviewed' }
};

exports.ById = {
  0: { Id: 0, Name: 'Accepted' },
  1: { Id: 1, Name: 'Rejected' },
  2: { Id: 2, Name: 'Accepted and Reviewed' }
};
